module.exports = __webpack_public_path__ + "front/img/6_a.c89d8a38.png";